import { Button, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IBookedFromDeveloperContactsLayoutProps {
  onClick(): void;
}

export const NewbuildingBookedFromDeveloperSuccessModal: React.FC<
  React.PropsWithChildren<IBookedFromDeveloperContactsLayoutProps>
> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <UIHeading2>Скоро вам позвонит консультант и задаст уточняющие вопросы</UIHeading2>
      <div className={styles['button']}>
        {' '}
        <Button size="XS" onClick={onClick}>
          Понятно
        </Button>
      </div>
    </div>
  );
};
